
// External link handler
(function() {
  var currentDomain = location.hostname;
  function processLinks() {
    document.querySelectorAll('a:not([data-processed])').forEach(function(link) {
      var href = link.getAttribute('href');
      if (href && href.includes('http') && !href.includes(currentDomain)) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      } else {
        link.removeAttribute('target');
      }
      link.setAttribute('data-processed', 'true');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processLinks);
  } else {
    processLinks();
  }
})();

// Fallback for legacy code
if (typeof item === 'undefined') { window.item = {}; }
